import type { BoxProps, TextProps } from '@customerio/pluma-components/react';
import { Box, Text } from '@customerio/pluma-components/react';
import * as styles from './index.css';

export function ShimmerText({
  children,
  variant,
  size,
  ...rest
}: {
  children: React.ReactNode;
  variant?: 'default' | 'gradient';
  size?: TextProps['size'];
} & BoxProps) {
  return (
    <Box {...rest}>
      <Text
        size={size}
        className={variant === 'gradient' ? styles.shimmerTextGradient : styles.shimmerText}
        style={variant === 'gradient' ? { color: 'transparent' } : undefined}
      >
        {children}
      </Text>
    </Box>
  );
}
